import { Loader2 } from "lucide-react";
import { Card } from "@/components/ui/card";
import { TaskList } from "./TaskList";
import type { WorkspaceTask, UpdateTaskInput, CancelTaskResult } from "@/hooks/useWorkspaceTasks";
import type { WorkspaceProject } from "@/hooks/useWorkspaceProjects";

interface TasksInboxPanelProps {
  tasks: WorkspaceTask[];
  loading: boolean;
  isAdmin: boolean;
  currentMemberId: string | null;
  workspaceId: string;
  onComplete: (taskId: string, outcome: "positive" | "negative") => Promise<void>;
  onReopen: (taskId: string) => Promise<void>;
  onCancel: (taskId: string, reason?: string) => Promise<CancelTaskResult>;
  onUpdateDueDate: (input: {
    taskId: string;
    due_date: string | null;
    due_at: string | null;
    allowPastDue?: boolean;
  }) => Promise<void>;
  onUpdateTask: (input: UpdateTaskInput) => Promise<void>;
  onDuplicate?: (task: WorkspaceTask) => void;
  projects: WorkspaceProject[];
  title?: string;
  description?: string;
}

export function TasksInboxPanel({
  tasks,
  loading,
  title = "Gerais — tarefas sem projeto",
  description = "Tarefas órfãs de todos os membros. Atribua a um projeto para organizá-las no Kanban.",
  projects,
  ...listProps
}: TasksInboxPanelProps) {
  if (loading && tasks.length === 0) {
    return (
      <div className="flex items-center justify-center py-12">
        <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
      </div>
    );
  }

  return (
    <div className="space-y-3">
      <div>
        <h2 className="text-sm font-semibold">{title}</h2>
        <p className="text-xs text-muted-foreground mt-0.5">{description}</p>
      </div>
      {tasks.length === 0 && !loading ? (
        <Card className="p-8 text-center text-muted-foreground text-sm">
          Nenhuma tarefa órfã no momento.
        </Card>
      ) : (
        <TaskList tasks={tasks} loading={loading} projects={projects} {...listProps} />
      )}
    </div>
  );
}
